module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "layer-1-copy0-1-1.2863ba2a.png";